import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import { RiEditLine, RiFileList2Line, RiFileList3Line, RiGroup2Line, RiLogoutBoxLine, RiMoneyDollarBoxLine, RiShieldUserLine } from "react-icons/ri";
import HeaderDropdownToggle from "../content/CustomDropdowns/HeaderDropdownToggle";
import * as auth from "../../store/ducks/auth.duck";

class UserProfile extends React.Component {
    constructor() {
        super();

        this.state = {
            open: false,
            animateClose: false,
        };

        this.closeTimeout = null;
    }

    handleToggle = (isOpen) => {
        if (this.closeTimeout) {
            clearTimeout(this.closeTimeout);
        }

        if (!isOpen) {
            this.setState({ animateClose: true });

            this.closeTimeout = setTimeout(() => {
                this.setState({ isOpen, animateClose: false });
            }, 300);
        } else {
            this.setState({ isOpen });
        }
    };

    componentWillUnmount() {
        if (this.closeTimeout) {
            clearTimeout(this.closeTimeout);
        }
    }

    render() {
        const { user, showHi, showAvatar } = this.props;
        const { isOpen, animateClose } = this.state;
        const fullname = user?.usr_name ?? "";
        const firstname = fullname.split(" ")[0];

        return (
            <Dropdown show={isOpen} className="kt-header__topbar-item kt-header__topbar-item--user" drop="down" alignRight onToggle={this.handleToggle}>
                <Dropdown.Toggle as={HeaderDropdownToggle} id="dropdown-toggle-user-profile">
                    <div className="kt-header__topbar-user">
                        {showHi && <span className="kt-header__topbar-username kt-hidden-mobile">{firstname}</span>}

                        {showAvatar && <div className="kt-header__initials">{firstname?.substring(0, 1)}</div>}
                    </div>
                </Dropdown.Toggle>

                <Dropdown.Menu className={`dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl dropdown-menu-estilo${animateClose ? " dropdown-close" : ""}`}>
                    <div className="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x">
                        {showAvatar &&
                            (user.foto ? (
                                <div className="kt-user-card__avatar">
                                    <span className="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success">
                                        <img alt="" src={user.foto ? user.foto.url : "/images/no-profile.png"} />
                                    </span>
                                </div>
                            ) : (
                                <div className="kt-header__initials">{firstname?.substring(0, 1)}</div>
                            ))}

                        <div className="d-flex flex-column" style={{ gap: 2, overflow: "auto" }}>
                            <div className="kt-user-card__name">{fullname}</div>
                            <div className="kt-user-card__email">{user.usr_email}</div>
                        </div>
                    </div>

                    <div className="kt-notification">
                        <Link to="/perfil" className="kt-notification__item" onClick={() => this.handleToggle(false)}>
                            <div className="kt-notification__item-icon">
                                <RiEditLine size={20} />
                            </div>
                            <div className="kt-notification__item-details">
                                <div className="kt-notification__item-title">Alterar dados</div>
                            </div>
                        </Link>

                        <Link to="/perfil/apidocs" className="kt-notification__item" onClick={() => this.handleToggle(false)}>
                            <div className="kt-notification__item-icon">
                                <RiFileList2Line size={20} />
                            </div>
                            <div className="kt-notification__item-details">
                                <div className="kt-notification__item-title">API e documentação</div>
                            </div>
                        </Link>

                        {user?.usr_is_admin ? (
                            <>
                                <Link to="/usuarios" className="kt-notification__item" onClick={() => this.handleToggle(false)}>
                                    <div className="kt-notification__item-icon">
                                        <RiGroup2Line size={20} />
                                    </div>
                                    <div className="kt-notification__item-details">
                                        <div className="kt-notification__item-title">Controle de usuários</div>
                                    </div>
                                </Link>

                                <Link to="/financeiro" className="kt-notification__item" onClick={() => this.handleToggle(false)}>
                                    <div className="kt-notification__item-icon">
                                        <RiMoneyDollarBoxLine size={20} />
                                    </div>
                                    <div className="kt-notification__item-details">
                                        <div className="kt-notification__item-title">Financeiro</div>
                                    </div>
                                </Link>
                            </>
                        ) : null}

                        <Link to="/termos-de-uso-e-politica-de-privacidade#politica-de-privacidade" target="_blank" className="kt-notification__item" onClick={() => this.handleToggle(false)}>
                            <div className="kt-notification__item-icon">
                                <RiShieldUserLine size={20} />
                            </div>
                            <div className="kt-notification__item-details">
                                <div className="kt-notification__item-title">Política de privacidade</div>
                            </div>
                        </Link>

                        <Link to="/termos-de-uso-e-politica-de-privacidade#termos-de-uso" target="_blank" className="kt-notification__item" onClick={() => this.handleToggle(false)}>
                            <div className="kt-notification__item-icon">
                                <RiFileList3Line size={20} />
                            </div>
                            <div className="kt-notification__item-details">
                                <div className="kt-notification__item-title">Termos de uso</div>
                            </div>
                        </Link>

                        <Link to="/logout" className="kt-notification__item" onClick={() => this.handleToggle(false)}>
                            <div className="kt-notification__item-icon">
                                <RiLogoutBoxLine size={20} />
                            </div>
                            <div className="kt-notification__item-details">
                                <div className="kt-notification__item-title">Sair</div>
                            </div>
                        </Link>
                    </div>
                </Dropdown.Menu>
            </Dropdown>
        );
    }
}

const mapStateToProps = ({ auth: { user } }) => ({ user });

export default withRouter(connect(mapStateToProps, auth.actions)(UserProfile));
